import PropTypes from 'prop-types';
import React from 'react';
import { ColorPicker } from '../..';
import Box from '../../layout/Box';

const ColorField = ({label, defaultValue, resetValue, onChange}) => (
  <Box direction="row" justifyContent="space-between" alignItems="center">
    <label>{label}</label>
    <ColorPicker color={defaultValue} resetValue={resetValue} onChange={onChange}/>
  </Box>
);

ColorField.propTypes = {
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.string.isRequired,
  resetValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ColorField;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/ColorField/index.js